import { isAndroid } from './Platform';

import { AudioSoundManagerModule } from '../components/android/AudioSoundManager/AudioSoundManager';

export const startConnectionListener = () => {
  if (isAndroid) {
    AudioSoundManagerModule.listenForHDMIEvents();
  }
};
